(function($) {
    "use strict";

    $(document).ready(function () {

    });

    document.addEventListener("DOMContentLoaded", function(event) {
        if (document.body.contains(document.querySelector('#secondform'))) {
            document.querySelector('#secondform').classList.toggle('hidden');
        }

        if (document.body.contains(document.querySelector('.toptime'))) {

            let toptime = document.querySelector('.toptime'),
                t = toptime.getAttribute("data-timestamp-1") * 1000,
                myInterval;

            let updateTimeAndInterval = function (t){
                let m = moment.tz(t,moment.tz.guess());

                toptime.innerHTML = m.format("dddd MMMM DD, YYYY - h:mm A z");
                document.querySelector('#side_date').innerHTML = m.format("MMMM DD");
                document.querySelector('#side_dotw').innerHTML = m.format("dddd");
                document.querySelector('#side_time').innerHTML = m.format("hh:mm A");
                document.querySelector('#side_timezone').innerHTML = m.format("z");

                let diffTime = t - Date.now();
                let duration = moment.duration(diffTime, 'milliseconds');
                let interval = 1000;

                let countdown = function() {
                    duration = moment.duration(duration - interval, 'milliseconds');
                    document.querySelector('#side_days').innerHTML = Math.floor(duration.asDays());
                    document.querySelector('#side_hours').innerHTML = duration.hours();
                    document.querySelector('#side_minutes').innerHTML = duration.minutes();
                    document.querySelector('#side_seconds').innerHTML = duration.seconds();
                }

                clearInterval(myInterval);
                countdown();
                myInterval = setInterval(countdown, interval);
            };


            updateTimeAndInterval(t);

            $("#timezone_dropdown").on('change',function () {
                let dropdown_timestamp = toptime.getAttribute("data-timestamp-"+this.value) * 1000;
                //let on24_key = toptime.getAttribute("data-on24_key-"+this.value);
                //let on24_event_id = toptime.getAttribute("data-on24_event_id-"+this.value);
                let big_marker_id = toptime.getAttribute("data-big_marker_id-"+this.value);


                //$("#subscriber-form input[name='on24_key']").val(on24_key);
                //$("#subscriber-form input[name='on24_event_id']").val(on24_event_id);
                $("#subscriber-form input[name='big_marker_id']").val(big_marker_id);

                //$('#on24_url').attr('href','https://event.on24.com/wcc/r/'+on24_event_id+'/'+on24_key+'?mode=login&email='+$('#on24_url').data('email'));

                updateTimeAndInterval(dropdown_timestamp);
            });

            if ( $( "#timezone_dropdown" ).length ) {
                $("#timezone_dropdown").trigger('change');
            }

        }
    });

    // recaptcha code
    let reCaptchaCorrect = true;
    let correctCaptcha = function(response) {
        reCaptchaCorrect = true;
        changeSubmit();
    };


    // verify all sections are filled in
    function validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function toggleActive(element) {
        element.classList.toggle('active');
    }


})(jQuery);
